// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vMediaQuery from 'v-media-query'
import ElementUI from 'element-ui'

import localeEN from 'element-ui/lib/locale/lang/en'
import localeAT from 'element-ui/lib/locale/lang/de'
import localeDE from 'element-ui/lib/locale/lang/de'
import localeFR from 'element-ui/lib/locale/lang/fr'
import localeSL from 'element-ui/lib/locale/lang/sl'


import VueLocalStorage from 'vue-localstorage';
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts/highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import 'element-ui/lib/theme-default/index.css'

import Localization from './localization';
import Users from './users';
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/volume-up'
import 'vue-awesome/icons/cloud'
import 'vue-awesome/icons/refresh'
import 'vue-awesome/icons/line-chart'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/close'
import 'vue-awesome/icons/sign-out'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/file-word-o'
import 'vue-awesome/icons/hourglass-half'
import 'vue-awesome/icons/thumb-tack'
import 'vue-awesome/icons/sticky-note'


import Icon from 'vue-awesome/components/Icon'

Vue.component('icon', Icon)
Vue.use(VueLocalStorage);
Vue.use(ElementUI, { locale:localeEN})
Vue.use(vMediaQuery)
Vue.use(Localization,  {locale:localeEN, EN:localeEN, AT:localeAT, DE:localeDE, FR:localeFR, SL:localeSL});
Vue.use(Users);
Vue.use(require('vue-shortkey'))

setGraphLanguage(Highcharts, Localization.getTranslations());

HighchartsExporting(Highcharts);
Vue.use(VueHighcharts,{Highcharts});

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



function setGraphLanguage(hcharts, languages){
    try{
      let language = 'en';
      if(window.localStorage.settings){
          var settings = JSON.parse(window.localStorage.settings);
          if (settings && settings.interface && settings.interface.language){
            language = settings.interface.language
          }
          //language = JSON.parse(window.localStorage.settings);
      }
      let languagePack = languages[language];

      hcharts.setOptions({
        lang: {
          loading: languagePack.common.graph_loading,
          months: languagePack.common.month_Names,
          shortMonths: languagePack.common.graph_shortMonths,
          weekdays: languagePack.common.graph_day_name,
          exportButtonTitle: languagePack.common.graph_export,
          printButtonTitle: languagePack.common.graph_printButt,
          downloadPNG: languagePack.common.graph_down_PNG,
          downloadJPEG: languagePack.common.graph_down_JPG,
          downloadPDF: languagePack.common.graph_down_PDF,
          downloadSVG: languagePack.common.graph_down_SVG,
          resetZoom: languagePack.common.graph_zoom_reset,
          resetZoomTitle: languagePack.common.graph_zoom_reset
        }
      });
    }catch(err){
      console.error(err);
    }
}



// WEBPACK FOOTER //
// ./src/main.js